import { createReducer, on } from '@ngrx/store';

import { TenantDtoStoreModel } from '@domain/tenant/tenant.models';

import { synchroniseTenantsCache } from './tenants.actions';

export interface TenantsState {
  tenants: TenantDtoStoreModel[] | undefined;
  isLoading: boolean;
  error: string | undefined;
}

export const initialState: TenantsState = {
  tenants: undefined,
  isLoading: false,
  error: undefined,
};

export const tenantsFeatureKey = 'tenants';

export const tenantsReducer = createReducer(
  initialState,
  on(synchroniseTenantsCache, (_, { tenants, isLoading, error }): TenantsState => ({ tenants, isLoading, error }))
);
